import { locale } from "../i18n.js";

/**
 * Messages the page shows as the server wrote them (api.ts, hosted-api.ts,
 * the blocked screen): the app Worker's sign-in answers (infra/app), the
 * platform's account answers it passes on, the sign-in service's, and the
 * local host's. The servers speak English and do not know the page's
 * language, so the common ones are looked up here, by their exact English,
 * and anything else is shown as it came. A message reworded on a server
 * falls back to its English here, which is the safe way round.
 */
const INDONESIAN: Readonly<Record<string, string>> = {
  // The app Worker (infra/app/src/index.js).
  "Create your account in the Ark Platform portal, then sign in here.": "Buat akun kamu di portal Ark Platform, lalu masuk di sini.",
  "Enter your email and password.": "Masukkan email dan kata sandi kamu.",
  "Could not sign in.": "Tidak bisa masuk.",
  "Could not start your session.": "Sesi kamu tidak bisa dimulai.",
  "Please sign in.": "Kamu perlu masuk dulu.",
  "Too many requests. Try again in a minute.": "Terlalu banyak permintaan. Coba lagi dalam satu menit.",
  "The service could not complete this request.": "Layanan tidak bisa menyelesaikan permintaan ini.",
  "The app could not complete this request.": "Aplikasi tidak bisa menyelesaikan permintaan ini.",
  "The screen did not answer.": "Layar tidak menjawab.",
  // The sign-in service (Supabase Auth), passed on by the Worker.
  "Invalid login credentials": "Email atau kata sandi salah.",
  "Email not confirmed": "Email kamu belum dikonfirmasi.",
  // The platform (ark-platform), passed on by the Worker.
  "Account is suspended.": "Akun ditangguhkan.",
  "Account is unavailable or suspended.": "Akun tidak tersedia atau ditangguhkan.",
  "Account is not active.": "Akun tidak aktif.",
  "An active Ark Bot subscription is required.": "Kamu perlu langganan Ark Bot yang aktif.",
  "An active subscription is required.": "Kamu perlu langganan yang aktif.",
  "Insufficient credits. Redeem a voucher to top up.": "Kredit tidak cukup. Tukarkan voucher untuk mengisi ulang.",
  // The local host (packages/hosted).
  "Invalid username or password.": "Nama pengguna atau kata sandi salah.",
  "This login card has changed. Use its current fields and options.": "Kartu login sudah berubah. Gunakan kolom dan pilihan yang terbaru.",
  "Choose an option shown on this login card.": "Pilih opsi yang ada pada kartu login ini.",
  "Only the displayed login fields can be submitted.": "Hanya kolom login yang ditampilkan yang bisa dikirim.",
  "Fill in the required login fields.": "Isi kolom login yang wajib diisi.",
  "Sign-in could not be submitted. Please try again.": "Login belum bisa dikirim. Silakan coba lagi.",
  "The sign-in page changed. Please use the updated card.": "Halaman login berubah. Gunakan kartu yang diperbarui.",
  "Sign-in is still waiting. Complete the step shown here, then try again.": "Login masih menunggu. Selesaikan langkah yang ditampilkan, lalu coba lagi.",
  "Complete the next sign-in step shown below.": "Selesaikan langkah login berikutnya di bawah ini.",
  "Scan the QR code in this login-page screenshot. Open the image to view it full size.": "Pindai kode QR pada tangkapan halaman login ini. Buka gambar untuk ukuran penuh.",
  "This sign-in step cannot be completed with the detected fields. Choose another available method, or cancel.": "Langkah login ini belum bisa diselesaikan dengan kolom yang terdeteksi. Pilih cara lain yang tersedia, atau batalkan.",
  "Use a password between 8 and 128 characters.": "Pakai kata sandi 8 sampai 128 karakter.",
};

/** A server's message in the page's language, when it is one of the known ones; otherwise as it came. */
export function serverText(message: string): string {
  // Typed as text, but it is whatever the server sent: anything else goes by untouched.
  if (locale() !== "id" || typeof message !== "string") return message;
  return INDONESIAN[message.trim()] ?? message;
}
